(function () {
  'use strict';
  function withVariant(value, variant, params) {
    var raw = String(value || '').replace(/\?variant=/g, function (match, offset, source) {
      return source.slice(0, offset).indexOf('?') < 0 ? match : '&variant=';
    });
    var url = new URL(raw, window.location.origin);
    if (variant != null && String(variant)) url.searchParams.set('variant', String(variant));
    Object.keys(params || {}).forEach(function (key) {
      if (params[key] == null) url.searchParams.delete(key);
      else url.searchParams.set(key, String(params[key]));
    });
    return url.toString();
  }
  window.WillowProductURL = { withVariant: withVariant };
})();
